import React, { Component } from "react";
import Layout from "@pages/candidate/Layout";
import {
    Heading,
    Container,
    Button,
    Box,
    Avatar,
    Text,
    IconButton,
    HStack,
    Spinner,
} from "@chakra-ui/react";
import { Separator, View, OfferDetailsSkeleton, ModalBox } from '@components';
import { IconStar, IconAvatar } from "@/assets/Icons";
import { getOffer, like, unlike, apply } from "@lib/datahandlers/person";
import { t } from '@lang/i18n';
import { AuthContext } from '@contexts/AuthContext';
import { Link } from "react-router-dom";

class OfferDetailsScreen extends Component {
    static contextType = AuthContext;

    offer_id = this.props.match.params.id;

    state = {
        loading: false,
        offer: null,
        confirm_apply: false,
        applying: false,
    };

    componentDidMount() {
        document.title = 'VisioJob';
        this.getOffer();
    }

    getOffer = async () => {
        this.setState({ loading: true });
        const response = await getOffer(this.offer_id);
        this.setState({ loading: false });

        if(response === 404);
        else if(response) {
            document.title = 'VisioJob | ' + (response.offer.title || 'Annonce');
            this.setState({offer: response.offer});
        }
        else this.context.toast({ description: t('global.general_error'), status: "warning", variant: 'subtle', duration: 3000 });
    }

    apply = async () => {
        if(!this.state.confirm_apply) return this.setState({confirm_apply: true});

        
        this.setState({applying: true});
        const success = await apply(this.offer_id);
        this.setState({applying: false});

        if(success) this.setState({offer:{...this.state.offer, applied: 1 }, confirm_apply: false});
        else this.context.toast({description: t('global.general_error'), status: "warning", variant: 'subtle', duration: 3000});
    }

    favoriteClick = async () => {
        let liked = this.state.offer.liked;
        this.setState({offer:{...this.state.offer, liked: !liked }})
        const success = await (liked? unlike(this.offer_id) : like(this.offer_id));
        if(!success) {
            this.setState({offer:{...this.state.offer, liked: liked }});
            this.context.toast({
                title: "",
                description: t('global.general_error'),
                status: "warning",
                variant: 'subtle',
                duration: 3000,
            });
        }
    }

    render() {
        const {offer, loading} = this.state;
        return (
            <Layout menuType="candidate" isNavBarVisible isFooterVisible>

                <ModalBox isOpen={this.state.confirm_apply} onClose={e => this.setState({confirm_apply: false})}>
                    <Text fontSize="20px" fontWeight="600">{t('candidate.search_job.applying.title')}</Text>
                    <Text mt="10px" textAlign="center">{t('candidate.search_job.applying.description')}</Text>
                    <HStack spacing="20px" mt="30px">
                        <Button 
                            width="140px" 
                            h="40px" 
                            bg="red.400" 
                            color="white" 
                            _hover={{opacity: ".8"}}
                            onClick={e => this.setState({confirm_apply: false})}
                            borderRadius="99px">
                            {t('global.cancel')}
                        </Button>
                        <Button 
                            width="140px" 
                            h="40px" 
                            bg="blue.main" 
                            color="white" 
                            _hover={{opacity: ".8"}}
                            onClick={this.apply}
                            borderRadius="99px">
                            {this.state.applying? <Spinner size="md"/> : t('global.confirm_2')}
                        </Button>
                    </HStack>
                </ModalBox>

                <Container maxW="container.md" bg="#FFFC" minHeight='calc(100vh - 100px)' py="36px" px={["16px", "", "", "100px"]} >

                    <Heading textAlign="center" fontSize="30px" m="auto" maxW="435px"> {t('candidate.search_job.details.title')} </Heading>
                    <Separator />

                    {/* Not found */}
                    <View if={!offer && !loading}>
                        <Box m="auto" textAlign="center">
                            <Heading m="auto" mt="80px" maxW="600px" fontWeight="500" color="#999" fontSize="20px">
                                {t('candidate.search_job.details.not_found')}
                            </Heading>
                        </Box>
                    </View>

                    {/* Loading */}
                    <View
                        if={loading}
                        className={'fadeIn'}
                        display="flex"
                        flexDir="row"
                        flexWrap="wrap"
                        justifyContent={["center", "", "", "space-between"]} >
                        <OfferDetailsSkeleton />
                    </View>

                    {/* Offer details */}
                    <View if={offer && !loading} fontSize="14px">
                        <Box display="flex" justifyContent="space-between" flexDir="row" pos="relative">
                            <Box>
                                <Link to={`/candidate/companies/${offer?.user?.id}`}>
                                    <ProfilePicture name={offer?.user?.company?.name} src={offer?.user?.picture} />
                                </Link>
                                <Box display="inline-block" flex="1" ml="1rem" verticalAlign="middle" maxW="calc(100% - 96px)">
                                    <Link to={`/candidate/companies/${offer?.user?.id}`}>
                                        <Box display="block" fontSize="20px" fontWeight="bold" maxW="calc(100% - 30px)" noOfLines={2}>{offer?.user?.company?.name}</Box>
                                    </Link>
                                    <Box display="block" m="0" color="gray.borders" noOfLines={2}>{offer?.user?.address}</Box>
                                </Box>
                            </Box>
                            <HStack 
                                w={["","","200px"]} 
                                h={["115px","","auto"]} 
                                pos={["absolute","","initial"]} 
                                top="0" right="0" 
                                justifyContent="space-between" 
                                alignItems={["flex-end","","center"]}
                                flexDir={["column-reverse", "", "row"]}>
                                {offer?.applied?
                                <Text 
                                    border="solid 
                                    2px" 
                                    cursor="default" 
                                    borderRadius="99px" 
                                    fontWeight="600" 
                                    color="blue.light" 
                                    lineHeight="38px"
                                    textAlign="center"
                                    w="150px" h="40px">
                                    {t('candidate.search_job.details.applied')}
                                </Text>
                                :
                                <Button 
                                    color="white" 
                                    borderRadius="99px" 
                                    bg="blue.main" 
                                    _hover={{opacity: .8}}
                                    onClick={this.apply}
                                    w="150px" h="40px">
                                    {t('candidate.search_job.details.apply')}
                                </Button>
                                }
                                <IconButton
                                    justifyContent="flex-end"
                                    minW="auto"
                                    colorScheme="none"
                                    _hover={{filter: 'brightness(1.2)'}}
                                    _focus={{boxShadow: 'none'}}
                                    title={offer?.liked? "Retirer des favoris" : "Ajouter aux favoris"}
                                    icon={<IconStar iconType="candidate" variant={offer?.liked? "filled" : "outline"} event={this.favoriteClick} />}
                                />
                            </HStack>
                        </Box>

                        <Text fontSize="18px" fontWeight="bold" mt={["60px","","18px"]} mb="5px">{offer?.title}</Text>
                        <AttrValue attr={t('candidate.search_job.details.number_position')} val={offer?.nbr_positions} />
                        <AttrValue attr={t('candidate.search_job.details.experience')} val={offer?.experiences.map(e=>e.name).join(', ')} />
                        <AttrValue attr={t('candidate.search_job.details.work_location')} val={offer?.address} />
                        <AttrValue attr={t('candidate.search_job.details.contracts')} val={offer?.contracts.map(e=>e.name).join(', ')} />
                        <AttrValue attr={t('candidate.search_job.details.salary_yearly_min')} val={offer?.salary_min ? `${offer.salary_min}€` : "---"} />
                        <AttrValue attr={t('candidate.search_job.details.salary_yearly_max')} val={offer?.salary_max ? `${offer.salary_max}€` : "---"} />
                        <Separator ml="1.5rem !important" my="16px !important" />
                        <Text>{offer?.description}</Text>
                    </View>


                </Container>
            </Layout>
        )
    }
}

const AttrValue = ({attr, val}) => (
    <Box>
        <Text display="inline">{attr} : </Text>
        <Text display="inline" fontWeight="bold">{val}</Text>
    </Box>
);

const ProfilePicture = ({name, src}) => {
    if(src)
        return <Avatar name={name} w="80px" h="80px" src={src} verticalAlign="middle" />
    else 
        return  <Box w="80px" h="80px" borderRadius="99px" bg="gray.bgApp" p="20px" display="inline-block" verticalAlign="middle">
                    <IconAvatar w="40px" h="40px"/>
                </Box>
};

export default OfferDetailsScreen;